<div fxFlex="column" class="reassign-dialog">

    <div class="dialog-header">
        Reassign - {{ title }}
    </div>

    <div class="reassign-container" fxLayout="column">
        <div class="reassign-question">
            Should the student see an icon indicating the questions he/she got incorrect on the previous attempt?
        </div>
        <mat-radio-group class="reassign-selection" [(ngModel)]="selectedOption" (change)="onOptionChange($event)" aria-label="Select an Option">
            <div fxLayout="column">
                <mat-radio-button class="reassign-option" [value]="true" (click)="onRadioClicked($event)">
                    Yes
                </mat-radio-button>
                <mat-checkbox class="sub-selection" [(ngModel)]="subYes" [disabled]="selectedOption == undefined || !selectedOption">
                    Student can see his/her responses to the questions that were incorrect.
                </mat-checkbox>
            </div>
            <div fxLayout="column">
                <mat-radio-button class="reassign-option" [value]="false" (click)="onRadioClicked($event)">
                    No
                </mat-radio-button>
                <mat-checkbox class="sub-selection" [(ngModel)]="subNo" [disabled]="selectedOption == undefined || selectedOption">
                    Allow the student to see his/her previous answers.
                </mat-checkbox>
            </div>
        </mat-radio-group>

        <div class="button-container" fxLayout="row" fxLayoutAlign="space-around center">
            <div>
                <button
                    class="cancel-button button"
                    mat-button
                    type="button"
                    (click)="onCancel()"
                >
                    Cancel
                </button>
            </div>
            <div>
                <button
                [disabled]="selectedOption === undefined"
                class="submit-button button"
                mat-button
                type="button"
                (click)="onReassign()"
            >
                Reassign
            </button>
            </div>
        </div>
    </div>
</div>
